import { createFileRoute } from '@tanstack/react-router';
import { ClientPortalAccessPage } from '@/features/portal/admin/ClientPortalAccessPage';

/**
 * «Accessi al portale»: gli accessi di tutti i clienti dell'azienda in una pagina, come
 * `/client-portal-access` di Lares. Il singolo cliente resta sulla sua scheda.
 */
export const Route = createFileRoute('/_app/client-portal-access')({ component: ClientPortalAccessPage });
